module.exports = __webpack_public_path__ + "static/img/border-4.f76a5faa.png";